import * as API from "@/services/";
import store from "@/store";

export function hasActives() {

	let company = store.getters.getActiveCompany;

	return !company ? false : true;
}

export async function setActives() {
	let companies = await API.getCompanies();

	let company = companies.result.find((item, index) => index === 0) || {};

	store.dispatch("setActiveCompany", company);

	return true;
}

export async function checkActives(to, from, next) {
	if (hasActives()) {
		next();
		return
	} else {
		// await setActives();
		next({
			name: 'formlist'
		})
	}
}

